require.context('../images', true); // Load all the images within this directory and all subdirectories.
